(function(global) {
  'use strict';
  var ids = {
    age: ['18-24', '25-34', '35-44', '45-54', '55+'],
    gender: ['woman', 'man', 'undisclosed'], struggle: ['fall', 'stay', 'deep', 'all'],
    severity: ['few', 'most', 'every'], mel: ['avoid', 'open', 'strongest']
  };
  var outcomes = ['stay_asleep', 'stay_asleep_mel', 'deep_sleep', 'deep_sleep_mel'];
  function valid(c) {
    var text = function(v, max) { return typeof v === 'string' && v.trim().length > 0 && v.length <= max; };
    var v1 = c && c.schemaVersion === 1 && c.rendererVersion === 1;
    var v2 = c && c.schemaVersion === 2 && c.rendererVersion === 2;
    if ((!v1 && !v2) || !text(c.version, 80)) return false;
    var keys = v1 ? outcomes : Object.keys(c.products || {});
    if (v1 && (!Array.isArray(c.pausedOutcomes) || c.pausedOutcomes.some(function(k) { return outcomes.indexOf(k) === -1; }))) return false;
    if (v2 && (!keys.length || keys.length > 16 || keys.some(function(k) {
      var p = c.products[k];
      return !/^[a-z0-9_-]{1,300}$/.test(k) || ['__proto__', 'constructor', 'prototype'].indexOf(k) !== -1 || !p || !/^[a-z0-9-]{1,255}$/.test(p.handle) || [true, false, null].indexOf(p.melatonin) === -1;
    }) || !c.sms || ['title', 'description', 'placeholder', 'submit', 'skip', 'consent'].some(function(k) { return !text(c.sms[k], k === 'consent' ? 1500 : 250); }) || !/^[a-zA-Z0-9]{1,40}$/.test(c.sms.listId))) return false;
    return Array.isArray(c.questions) && c.questions.length === 5 && Object.keys(ids).every(function(id, i) {
        var q = c.questions[i];
        return q && q.id === id && text(q.title, 250) && Array.isArray(q.answers) && q.answers.length === ids[id].length && q.answers.every(function(a, j) { return a && a.id === ids[id][j] && text(a.label, 250); });
      }) && c.rules && Object.keys(c.rules).length === 12 && ids.struggle.every(function(s) {
        return ids.mel.every(function(m) {
          var key = c.rules[s + ':' + m];
          return keys.indexOf(key) !== -1 && (v1 ? c.pausedOutcomes.indexOf(key) === -1 && (m !== 'avoid' || key.indexOf('_mel') === -1) : m !== 'avoid' || c.products[key].melatonin === false);
        });
      }) && c.explanations && keys.every(function(k) { return text(c.explanations[k], 1500); });
  }
  function select(answers, config, products) {
    var original = answers.mel === 'avoid' ? 'stay_asleep' : answers.mel === 'strongest' ? 'deep_sleep_mel' : answers.struggle === 'stay' ? 'stay_asleep_mel' : 'deep_sleep_mel';
    var v2 = config && config.schemaVersion === 2;
    var paused = config && config.pausedOutcomes || [];
    var keys = v2 ? Object.keys(config.products) : outcomes;
    var available = function(key) {
      var melatoninFree = v2 ? config.products[key] && config.products[key].melatonin === false : outcomes.indexOf(key) !== -1 && key.indexOf('_mel') === -1;
      return products[key] && products[key].available === true && products[key].variantId && (!products[key].requiresSellingPlan || products[key].subPlanId) && paused.indexOf(key) === -1 && (answers.mel !== 'avoid' || melatoninFree);
    };
    var configured = config && config.rules[answers.struggle + ':' + answers.mel];
    if (configured && available(configured)) return configured;
    if (available(original)) return original;
    return keys.find(available) || null;
  }
  function properties(recommendation, runId, version) {
    return { _sleep_quiz: 'true', _sleep_quiz_recommendation: recommendation, _sleep_quiz_run_id: runId, _sleep_quiz_version: version };
  }
  var api = { rendererVersion: 2, valid: valid, select: select, properties: properties };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.SandlandQuiz = api;
})(typeof window !== 'undefined' ? window : globalThis);
